import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import ravenMiddleware from './middleware/raven';
import rootReducer, { IState } from './reducers';

const configureStore = (): Store<IState> => {
  if (process.env.NODE_ENV === 'development' && module.hot) {
    const middlewares = [thunkMiddleware];
    const middlewareEnhancer = applyMiddleware(...middlewares);

    const enhancers = [middlewareEnhancer];
    const composedEnhancers = composeWithDevTools(...enhancers);

    const store: Store = createStore(rootReducer, composedEnhancers);

    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));

    return store;
  } else {
    const store = createStore(
      rootReducer,
      applyMiddleware(ravenMiddleware, thunkMiddleware),
    );

    return store;
  }
};

export default configureStore;

// Don't need all this stuff logged

// import monitorReducersEnhancer from './enhancers/monitorReducers';
// import loggerMiddleware from './middleware/logger';

// const configureStore = (preloadedState: {}): Store => {
//   if (process.env.NODE_ENV === 'development' && module.hot) {
//     const middlewares = [loggerMiddleware, thunkMiddleware];
//     const middlewareEnhancer = applyMiddleware(...middlewares);

//     const enhancers = [middlewareEnhancer, monitorReducersEnhancer];
//     const composedEnhancers = composeWithDevTools(...enhancers);

//     const store: Store = createStore(
//       rootReducer,
//       preloadedState,
//       composedEnhancers,
//     );

//     module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));

//     return store;
//   } else {
//     const store = createStore(
//       rootReducer,
//       preloadedState,
//       applyMiddleware(thunkMiddleware),
//     );

//     return store;
//   }
// };



// WEBPACK FOOTER //
// ./src/store/configureStore.ts